const Storeroom = {
  namespaced: true,

  state: {
    
  },

  actions: {
   
  },

  mutations: {
  }
}

export default Storeroom;